import React from 'react';
import PropTypes from 'prop-types';

import { HeadersList, CsvPreview } from '../Shared';

const csvHeaders = [
  'Gift Card Code*', 'Balance*', 'Initial Balance (defaults to Balance)',
];

const GiftCardsImport = ({
  onChange,
  preview,
  onSubmit,
  deleteGiftCards,
  busy,
}) => (
  <div className="c-wrapper">
    <div className="u-max-width-710 u-margin-auto">
      <div className="c-inner-wrapper u-pt">
        <form onSubmit={onSubmit}>
          <div className="layout">
            <div className="layout__item u-1/2 u-p-0">
              <div className="layout__item">
                <input
                  type="file"
                  onChange={onChange}
                  name="csv"
                />
              </div>
              <div className="layout__item u-6/7">
                <button
                  type="submit"
                  className="c-btn c-btn--medium u-width-100"
                  disabled={busy || !preview}
                >
                  Import gift cards
                </button>
                <button
                  type="button"
                  className="c-btn c-btn--medium u-width-100 u-mt"
                  disabled={busy}
                  onClick={deleteGiftCards}
                >
                  Wipe imported gift cards
                </button>
              </div>
            </div>
            <HeadersList
              fields={csvHeaders}
              className="layout__item u-1/2"
            />
          </div>
        </form>
        <CsvPreview display-if={preview} preview={preview} />
      </div>
    </div>
  </div>
);

GiftCardsImport.propTypes = {
  onChange: PropTypes.func.isRequired,
  preview: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  deleteGiftCards: PropTypes.func.isRequired,
  busy: PropTypes.bool.isRequired,
};

GiftCardsImport.defaultProps = {
  preview: null,
  importResults: null,
};

export default GiftCardsImport;
